import { createAsyncThunk } from "@reduxjs/toolkit";
import { phpClient } from "../../../network";
import { EmployeeRole, IRejectWithValue, PhpResponse } from "../../../types";
import { GetAllEmployeeRolesRequest } from "../../../types/request/user";

export const getAllEmployeeRoles = createAsyncThunk<EmployeeRole[], GetAllEmployeeRolesRequest, IRejectWithValue>(
    "user/getAllEmployeeRoles",
    async (data, { rejectWithValue }) => {
        try {
            const response = await phpClient.post<PhpResponse<EmployeeRole[]>>({
                url: "/employees/employee_role_list",
                data,
            });

            return response.data ?? [];
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);